import { forwardRef, useId } from "react";

import { cn } from "@/lib/utils";
import { Label } from "./label";
import { ErrorLabel } from "./error-label";

type TDefaultTextareaProps = Omit<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  "prefix"
>;

export type TextareaProps = TDefaultTextareaProps & {
  label?: string;
  error?: string
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ label, error, className, ...props }, ref) => {
  const id = useId()

  return (
    <div>
      <Label id={id}>{label}</Label>

      <textarea
        id={id}
        ref={ref}
        rows={3}
        className={cn(
          "block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 bg-white ring-inset ring-gray-300 placeholder:text-gray-400 outline-none",
          "focus:ring-2 focus:ring-inset focus:ring-blue-300 sm:text-sm sm:leading-6",
          props.disabled
            ? "cursor-not-allowed bg-gray-100 text-gray-500"
            : "text-gray-900",
          error && "ring-red-600",
          className
        )}
        {...props}
      />

      {error && error.length > 1 && <ErrorLabel>{error}</ErrorLabel>}
    </div>
  );
}
);
